// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__2jVGw","registerButton":"Modal_registerButton__2ag7S","closeButton":"Modal_closeButton__2hGeq"};